<template>
  <div class="footer-container">
    <div class="foot-item">
      <ul>
        <li>
          <a href="/about">关于传联</a>
        </li>
        <li>|</li>
        <li>
          <a href="javascript:;" @click="openSuggestForm">意见和建议</a>
        </li>
      </ul>
    </div>
    <div class="foot-item">
      <ul>
        <li>{{ companyInfo.company }}</li>
        <li>|</li>
        <li>
          <a href="http://beian.miit.gov.cn" target="_blank">{{
            companyInfo.copy
          }}</a>
        </li>
        <li>|</li>
        <li>{{ companyInfo.address }}</li>
      </ul>
    </div>
    <div class="foot-item">
      <a
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=52011102002505"
        target="_blank"
      >
        <img src="http://148.70.221.198/pc/icon/record.png" />
        贵公网安备52011102002525号
      </a>
    </div>
    <div class="suggest-form-wrapper">
      <el-dialog
        title="意见或建议"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
        custom-class="handlian-suggest-container"
        width="40%"
      >
        <el-form
          :model="ruleForm"
          label-position="top"
          :rules="suggestionRules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="填写意见或建议" prop="suggestion">
            <el-input
              type="textarea"
              v-model="ruleForm.suggestion"
              resize="none"
              maxlength="100"
              show-word-limit
              placeholder="欢迎您为我们投来宝贵的意见与建议！"
              :autosize="{ minRows: 4 }"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="handlian-btn"
              type="primary"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button class="handlian-btn" @click="resetForm('ruleForm')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { apiMap } from "../utils/apiMap";
export default {
  name: "Footer",
  data() {
    return {
      companyInfo: {
        address: "贵州省贵阳市花溪区林都国际",
        company: "贵州传联网络科技有限公司",
        copy: "黔ICP备 18012321号",
      },
      dialogVisible: false,
      ruleForm: {
        suggestion: "",
      },
      suggestionRules: {
        suggestion: [
          {
            required: true,
            min: 10,
            max: 100,
            message: "请输入10~100个字的意见或建议",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.setCompanyInformation();
  },
  methods: {
    openSuggestForm() {
      var loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if (loginUser) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请先登录",
        });
      }
    },
    setCompanyInformation() {
      var $this = this;
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["companyInfo"]["method"],
          url: apiMap["companyInfo"]["url"],
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            //result.data address company copy mobile
            $this.companyInfo = response.data.result.data;
            Store.dispatch("setCompanyInfo", response.data.result.data);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitSuggestion(this.ruleForm);
          this.dialogVisible = false;
          this.resetForm("ruleForm");
        } else {
          return false;
        }
      });
    },
    handleClose() {
      this.resetForm("ruleForm");
      this.dialogVisible = false;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitSuggestion(fromData) {
      var $this = this;
      var loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      $this
        .$axios({
          baseURL: apiMap["commonUrl"],
          method: apiMap["submitSuggest"]["method"],
          url: apiMap["submitSuggest"]["url"],
          data: `token=${loginUser.token}&agreement=${fromData.suggestion}`,
        })
        .then(function (response) {
          if (response.data.result.statusCode == 1) {
            $this.$message({
              message: "操作成功！",
              type: "success",
            });
          } else {
            setTimeout(() => {
              $this
                .$alert(response.data.result.data)
                .then(() => {})
                .catch(() => {});
            }, 500);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.footer-container {
  padding: 18px 0;
  text-align: center;
  line-height: 35px;
  color: #fff;
  font-size: 12px;
  background-color: #1a70db;
}

.foot-item ul {
  display: flex;
  justify-content: center;
}

.foot-item ul li {
  padding: 0 15px;
}

.foot-item ul li a {
  color: #fff;
}

.foot-item a {
  color: #fff;
}

.foot-item img {
  vertical-align: middle;
}

.suggest-form-wrapper {
  text-align: left;
}
</style>